import React from 'react';
import APTFeedDashboard from '../components/APTFeedDashboard';

const APTFeed: React.FC = () => {
  return (
    <div className='px-4 sm:px-6 lg:px-8 py-6'>
      <APTFeedDashboard />
    </div>
  );
};

export default APTFeed;
